/**
 * Find a heading element by its cid/tid numeric IDs regardless of title-slug prefix.
 * Handles:
 *   new format  #slug-cid-{n}          / #slug-cid-{n}-tid-{m}
 *   link format #cid-{n}               / #cid-{n}-tid-{m}
 *   old format  #chapterId-{n}         / #chapterId-{n}-topicId-{m}
 */
function findByCidTid(id) {
  const cidMatch = id.match(/(?:^|-)cid-(\d+)(?:-tid-(\d+))?$/);
  const oldTopicMatch = !cidMatch && id.match(/^chapterId-(\d+)-topicId-(\d+)$/);
  const oldChapterMatch = !cidMatch && !oldTopicMatch && id.match(/^chapterId-(\d+)$/);

  let cid, tid;
  if (cidMatch) {
    [, cid, tid] = cidMatch;
  } else if (oldTopicMatch) {
    [, cid, tid] = oldTopicMatch;
  } else if (oldChapterMatch) {
    [, cid] = oldChapterMatch;
  } else {
    return null;
  }

  const suffix = tid ? `cid-${cid}-tid-${tid}` : `cid-${cid}`;
  return [...document.querySelectorAll('[id]')].find(e =>
    e.id.endsWith(`-${suffix}`) || e.id === suffix
  ) || null;
}

export default function scrollToAnchor(
  hash = window.location.hash,
  {
    offset = 80, // keep headers visible
    maxWait = 2000,
    attemptEvery = 100,
    smooth = false, // smooth = false on initial load feels snappier
  } = {}
) {
  if (!hash || !hash.startsWith("#")) return;

  const id = decodeURIComponent(hash.slice(1));
  const start = Date.now();

  const tryScroll = () => {
    let el = document.getElementById(id);
    // Fallback: find by cid/tid suffix when the title slug has changed or
    // the hash uses an ID-only format (#cid-{n}) from a /link/ redirect.
    if (!el) el = findByCidTid(id);
    if (el) {
      const top = el.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top, behavior: smooth ? "smooth" : "auto" });
      return true;
    }
    if (Date.now() - start < maxWait) {
      return setTimeout(tryScroll, attemptEvery);
    }
  };

  tryScroll();
}
